var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"riddle-question justify-center align-end ma-0 mx-8 pa-2"},[_c('p',{staticClass:"text-body-1 text-sm-h5 text-md-h4 text-lg-h4 text-xl-h3 white--text ma-0 mt-0 unselectable norddruck"},[_vm._v(" "+_vm._s(_vm.question)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }